import { MessageHolder } from '@/components/Message';
import { ModalHolder } from '@/components/Modal';
import { NotificationHolder } from '@/components/Notification';
import { IS_POS, IS_WECOM } from '@/utils/env';
import { legacyLogicalPropertiesTransformer, StyleProvider } from '@ant-design/cssinjs';
import { App as AntApp, ConfigProvider } from 'antd';
import { ThemeProvider } from 'antd-style';
import zhCN from 'antd/es/locale/zh_CN';
import 'core-js/stable';
import { StrictMode, useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';
import { useThemeMode } from './components/Theme';
import { browserRouter } from './routes';
import { createCustomToken, themeConfig } from './theme';

if (IS_POS) {
  themeConfig.token.motion = false;
}

export const Root = () => {
  const [adminThemeMode] = useThemeMode();

  const themeMode = useMemo(() => {
    if (IS_POS) {
      // pos 模式下强制使用浅色模式
      return 'light';
    }
    if (adminThemeMode === 'auto') {
      // 如果是自动模式，则在企微中根据 ua 判断
      // @see: https://developer.work.weixin.qq.com/document/path/94555
      if (IS_WECOM) {
        return /ColorScheme\/Dark/i.test(navigator.userAgent) ? 'dark' : 'light';
      }
    }

    return adminThemeMode;
  }, [adminThemeMode]);

  return (
    <HelmetProvider>
      <Helmet>
        <title>VeeYung 企业后台</title>
      </Helmet>

      <StyleProvider hashPriority="low" transformers={[legacyLogicalPropertiesTransformer]}>
        <ConfigProvider theme={themeConfig} locale={zhCN} componentSize={IS_POS ? 'large' : 'middle'}>
          <ThemeProvider themeMode={themeMode} customToken={createCustomToken}>
            <AntApp>
              <ModalHolder />
              <MessageHolder />
              <NotificationHolder />
              {/* <BrowserRouter>
              <AppRoutes />
            </BrowserRouter> */}
              <RouterProvider
                router={browserRouter}
                future={{
                  v7_startTransition: true,
                }}
              />
            </AntApp>
          </ThemeProvider>
        </ConfigProvider>
      </StyleProvider>
    </HelmetProvider>
  );
};

const container = document.getElementById('root');
const root = createRoot(container);

if (IS_PROD) {
  root.render(<Root />);
} else {
  const strictMode = localStorage.getItem('app-strict-mode') === '1';
  if (strictMode) {
    console.log(
      '%c⚠️ React 严格模式运行中',
      'background-color: #fffbe6; color: white;  border: 1px solid #ffe58f; color:rgba(0, 0, 0, 0.88); padding: 3px 8px; border-radius: 6px;'
    );
    root.render(
      <StrictMode>
        <Root />
      </StrictMode>
    );
  } else {
    root.render(<Root />);
  }
}
